export default {
  "site.name": "USFansSheet",
  "site.tagline": "Explore, compare & organize the USFans Spreadsheet",
  "seo.homeTitle": "USFans Spreadsheet – Explore, Compare & Organize Resources",
  "seo.homeDesc": "USFansSheet is a clean, helpful hub for the USFans Spreadsheet. Browse categories, read original guides and comparisons, then shop on the main website.",
  "seo.guideTitle": "USFans Spreadsheet – The Complete Guide",
  "seo.guideDesc": "Learn what a USFans Spreadsheet is, how to use it, and what to look for in this original, in-depth guide with comparisons and FAQs.",

  "nav.home": "Home",
  "nav.guide": "Shopping Guide",
  "nav.categories": "Categories",
  "nav.faq": "FAQ",
  "nav.buy": "Buy It Now",
  "nav.visitMain": "Visit Main Website",

  "hero.eyebrow": "USFans Spreadsheet Resource Hub",
  "hero.title": "Explore, Compare & Organize the USFans Spreadsheet",
  "hero.subtitle": "USFansSheet is a clean, helpful hub built around the USFans Spreadsheet. Browse organized categories, read practical guides and compare resources — then head to the main website to shop everything in one place.",
  "hero.trust": "Independent resource · Updated regularly · Privacy & safety focused",
  "hero.cta.main": "USFans Spreadsheet",
  "hero.cta.buy": "Buy It Now",
  "hero.cta.guide": "Read the Guide",

  "what.title": "What Is a USFans Spreadsheet?",
  "what.text1": "A USFans Spreadsheet is a structured way to organize and browse creator and product information in a single, searchable view. Instead of jumping between scattered pages, a spreadsheet-style resource brings everything together so it is easier to scan, compare and understand.",
  "what.text2": "USFansSheet is built around this topic. We publish original guides, comparisons and FAQs that help you understand the resources available, and we point you to the main website where you can browse the full catalog.",
  "what.cta": "Explore the Spreadsheet Guide",

  "categories.title": "Browse by Category",
  "categories.subtitle": "Jump straight to the collection you are looking for on the main website.",
  "drop.label": "Choose a category",
  "drop.hint": "Select a category to continue",

  "cat.shoes": "Shoes",
  "cat.hoodies": "Hoodies / Sweaters",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jackets",
  "cat.pants": "Pants / Shorts",
  "cat.headwear": "Headwear",
  "cat.sets": "Sets",
  "cat.underwear": "Underwear / Underpants",
  "cat.jersey": "Jersey",
  "cat.accessories": "Accessories",
  "cat.bags": "Bags",
  "cat.belts": "Belts",
  "cat.perfumes": "Perfumes",
  "cat.other": "Other Stuff",

  "features.title": "Why USFansSheet",
  "features.1.title": "Organized",
  "features.1.text": "Everything is grouped into clear categories, so you can find what you need without digging through scattered pages.",
  "features.2.title": "Easy to compare",
  "features.2.text": "Use structured guides and simple comparison tables to weigh your options before you click through.",
  "features.3.title": "Safe & helpful",
  "features.3.text": "We keep things clear, honest and focused on helping you make better decisions — no clutter, no tricks.",

  "compare.title": "USFans Spreadsheet vs. Traditional Search",
  "compare.colFeature": "Feature",
  "compare.colA": "Spreadsheet",
  "compare.colB": "Traditional Search",
  "compare.row1.f": "Structured information",
  "compare.row1.a": "Yes",
  "compare.row1.b": "Limited",
  "compare.row2.f": "Easy comparison",
  "compare.row2.a": "Yes",
  "compare.row2.b": "Limited",
  "compare.row3.f": "Organization",
  "compare.row3.a": "High",
  "compare.row3.b": "Low",
  "compare.row4.f": "Filtering",
  "compare.row4.a": "Possible",
  "compare.row4.b": "Limited",
  "compare.row5.f": "Beginner friendly",
  "compare.row5.a": "Yes",
  "compare.row5.b": "Medium",
  "compare.row6.f": "Topic-specific resources",
  "compare.row6.a": "Yes",
  "compare.row6.b": "Mixed",

  "articlePromo.title": "Read the Full USFans Spreadsheet Guide",
  "articlePromo.text": "New to the topic? Our in-depth guide explains what a USFans Spreadsheet is, how to use it and what to look for — all in one original article.",
  "articlePromo.cta": "Open the Guide",

  "faq.title": "Frequently Asked Questions",
  "faq.q1": "What is a USFans Spreadsheet?",
  "faq.a1": "It is a structured, searchable way to organize creator and product information in one view, making it easier to scan, compare and understand.",
  "faq.q2": "Is USFansSheet the official USFans website?",
  "faq.a2": "No. USFansSheet is an independent informational resource. For the full catalog, please visit the main website.",
  "faq.q3": "Where can I browse the products?",
  "faq.a3": "Use the category menu above or visit the main website directly. Every category links to the matching section there.",
  "faq.q4": "Do you sell products on this site?",
  "faq.a4": "No. This site provides guides and resources. All products are available on the main website.",
  "faq.q5": "Is my information safe?",
  "faq.a5": "We do not collect personal data or payment details. Always verify important information and avoid suspicious links.",
  "faq.q6": "How often is the content updated?",
  "faq.a6": "We review and refresh our guides regularly, but prices, stock and shipping can change — always check the main website for current details.",

  "article.h1": "USFans Spreadsheet: The Complete Guide",
  "article.short": "A USFans Spreadsheet is a structured, searchable resource that organizes creator and product information in one place, making it easier to browse, compare and understand. This guide explains how it works and what to look for.",
  "article.intro": "If you have come across the term “USFans Spreadsheet” and want to understand what it really means and how to use it, you are in the right place. This guide explains the idea in plain language, shows what to look for and helps you get the most out of these resources. We also show where to find the full catalog on the main website.",
  "article.toc.title": "Table of contents",
  "article.toc.1": "What Is a USFans Spreadsheet?",
  "article.toc.2": "Why People Use a Spreadsheet",
  "article.toc.3": "How to Use a USFans Spreadsheet",
  "article.toc.4": "Spreadsheet vs. Traditional Search",
  "article.toc.5": "What to Look For in a Good Resource",
  "article.toc.6": "Frequently Asked Questions",
  "article.s1.title": "What Is a USFans Spreadsheet?",
  "article.s1.p": "A USFans Spreadsheet is a structured way to organize creator and product information in a single, searchable view. Think of it as a clean table that groups related items together — names, categories, links and details — so you can scan everything at a glance instead of clicking through many separate pages. The goal is simple: make information easier to find, compare and understand.",
  "article.s2.title": "Why People Use a Spreadsheet",
  "article.s2.p": "Spreadsheets are popular for one simple reason: they reduce the effort of searching. When information is spread across many pages, finding and comparing options takes time. A well-organized spreadsheet brings related items into one place, so you can see patterns, spot differences and make decisions faster. For a topic like USFans, where there are many categories and resources, that structure is especially useful.",
  "article.s3.title": "How to Use a USFans Spreadsheet",
  "article.s3.intro": "Here is a simple, step-by-step way to get started:",
  "article.s3.1": "Start with the categories — most spreadsheets group items by category, such as Shoes, Hoodies / Sweaters, T-Shirts, Jackets and more. Start with the group that matches what you are looking for.",
  "article.s3.2": "Scan and compare — look across rows and columns to compare names, details and links side by side.",
  "article.s3.3": "Follow the source — a good spreadsheet links back to the original source. Use those links to verify details and see the full picture.",
  "article.s3.4": "Verify before you act — prices, stock and shipping can change. Always check the main website for the most current information.",
  "article.s4.title": "Spreadsheet vs. Traditional Search",
  "article.s5.title": "What to Look For in a Good Resource",
  "article.s5.p": "Not all spreadsheets are created equal. A good resource is clearly organized, easy to read and links back to a trustworthy source. It should be updated regularly and should never pressure you into anything. Above all, it should respect your privacy and never ask for passwords, payment details or other sensitive information. If a resource asks for that, treat it as a red flag and leave.",
  "article.related": "Looking for more? Head back to the homepage to browse all categories and resources, or read related guides on our main website.",
  "article.back": "Back to homepage",
  "article.cta": "Browse the full catalog on the main website",
  "article.meta.author": "USFansSheet Editorial Team",
  "article.meta.date": "Updated regularly",

  "footer.desc": "An independent, helpful resource built around the USFans Spreadsheet. Browse categories, read guides and head to the main website to shop everything in one place.",
  "footer.resources": "Resources",
  "footer.resources.guide": "Spreadsheet Guide",
  "footer.resources.categories": "Categories",
  "footer.resources.faq": "FAQ",
  "footer.main": "Main Website",
  "footer.main.desc": "Visit the main website to browse the full catalog.",
  "footer.disclaimer": "USFansSheet is an independent informational resource and is not affiliated with the main website. All products and purchases are handled on the main website.",
  "footer.copyright": "© 2026 USFansSheet. All rights reserved.",

  "resources.title": "Explore USFans Resources",
  "resources.subtitle": "Handy guides and references to help you browse, compare and shop with confidence.",
  "res.learnMore": "Learn more",
  "res.spreadsheet.title": "USFans Spreadsheet",
  "res.spreadsheet.text": "Structured guides to explore and organize creator resources.",
  "res.directory.title": "Creator Directory",
  "res.directory.text": "Understand how creator directories and lists work.",
  "res.reviews.title": "Reviews",
  "res.reviews.text": "What to check before you shop, explained honestly.",
  "res.comparisons.title": "Comparisons",
  "res.comparisons.text": "Compare resources side by side to decide faster.",
  "res.safety.title": "Safety Center",
  "res.safety.text": "Privacy, account security and responsible-use tips.",
  "res.guides.title": "Guides",
  "res.guides.text": "Practical tutorials for beginners and advanced users.",

  "articles.title": "USFans Pillar Guides",
  "articles.subtitle": "Ten original guides covering the topics people search for most.",
  "articles.read": "Read guide",
  "articles.related": "Related guides",

  "article.notFound": "Article not found",
};